export const Divider = ({ padding = 'py-2' }) => {
  return (
    <div className={padding}>
      <hr style={{ borderColor: '#5C5C98' }} />
    </div>
  );
};
